import { apiConfig } from 'core-lib/config/config';
import { putMethod } from 'core-lib/utils/apiV2';
import { customToast } from 'core-lib/utils/customToast';

export const updateUserAddress = async (payload) => {
  const endPoint = `${apiConfig('userNew')}/v1/user/address/update`;
  const { response, error }: any = await putMethod({ endPoint, body: payload });

  if (response) {
   
    return { response };
  } else if (error) {
    customToast({
      label: error?.message || 'Something went wrong',
      variant: 'criticalNotPriority',
    });
    return { error };
  }
};
